"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactRouterDom = require("react-router-dom");

var _reactJss = require("react-jss");

/* eslint-disable */
var LockedstylesWithProps = function LockedstylesWithProps(props) {
  return {};
};

var Lockedstyles = {};
var styles = (0, _reactJss.createUseStyles)(function (theme) {
  return {
    NavTopBarSubMenu: theme.NavTopBarSubMenu,
    NavTopBarSubMenuActive: theme.NavTopBarSubMenuActive,
    NavTopBarLink_Indicator_Inactive: theme.NavTopBarLink_Indicator_Inactive,
    NavTopBarLink_Indicator_Active: theme.NavTopBarLink_Indicator_Active,
    NavTopBarSubMenu_Controller: theme.NavTopBarSubMenu_Controller,
    NavTopBarSubMenu_Controller_Active: theme.NavTopBarSubMenu_Controller_Active,
    NavTopBarSubMenuContent_Show: theme.NavTopBarSubMenuContent_Show,
    NavTopBarSubMenuContent_Hide: theme.NavTopBarSubMenuContent_Hide
  };
});
/**
 * Create a vertical accordion Menu for the NavTopBar
 */

var NavTopBarSubMenu = /*#__PURE__*/_react["default"].forwardRef(function NavTopBarSubMenu(props, ref) {
  var Slug = props.Slug,
      SlugList = props.SlugList,
      ControllerContent = props.ControllerContent,
      WithActiveIndicator = props.WithActiveIndicator,
      ClassOverrideNavTopBarSubMenu = props.ClassOverrideNavTopBarSubMenu,
      ClassExtendNavTopBarSubMenu = props.ClassExtendNavTopBarSubMenu,
      ClassOvverideNavTopBarSubMenuActive = props.ClassOvverideNavTopBarSubMenuActive,
      ClassExtendNavTopBarSubMenuActive = props.ClassExtendNavTopBarSubMenuActive,
      ClassExtendNavTopBarLink_Indicator_Inactive = props.ClassExtendNavTopBarLink_Indicator_Inactive,
      ClassExtendNavTopBarLink_Indicator_Active = props.ClassExtendNavTopBarLink_Indicator_Active,
      ClassOverrideNavTopBarSubMenu_Controller = props.ClassOverrideNavTopBarSubMenu_Controller,
      ClassExtendNavTopBarSubMenu_Controller = props.ClassExtendNavTopBarSubMenu_Controller,
      ClassOverrideNavTopBarSubMenu_Controller_Active = props.ClassOverrideNavTopBarSubMenu_Controller_Active,
      ClassExtendNavTopBarSubMenu_Controller_Active = props.ClassExtendNavTopBarSubMenu_Controller_Active,
      ClassOverrideNavTopBarSubMenuContent_Show = props.ClassOverrideNavTopBarSubMenuContent_Show,
      ClassExtendNavTopBarSubMenuContent_Show = props.ClassExtendNavTopBarSubMenuContent_Show,
      ClassOverrideNavTopBarSubMenuContent_Hide = props.ClassOverrideNavTopBarSubMenuContent_Hide,
      ClassExtendNavTopBarSubMenuContent_Hide = props.ClassExtendNavTopBarSubMenuContent_Hide,
      className = props.className,
      children = props.children,
      other = (0, _objectWithoutProperties2["default"])(props, ["Slug", "SlugList", "ControllerContent", "WithActiveIndicator", "ClassOverrideNavTopBarSubMenu", "ClassExtendNavTopBarSubMenu", "ClassOvverideNavTopBarSubMenuActive", "ClassExtendNavTopBarSubMenuActive", "ClassExtendNavTopBarLink_Indicator_Inactive", "ClassExtendNavTopBarLink_Indicator_Active", "ClassOverrideNavTopBarSubMenu_Controller", "ClassExtendNavTopBarSubMenu_Controller", "ClassOverrideNavTopBarSubMenu_Controller_Active", "ClassExtendNavTopBarSubMenu_Controller_Active", "ClassOverrideNavTopBarSubMenuContent_Show", "ClassExtendNavTopBarSubMenuContent_Show", "ClassOverrideNavTopBarSubMenuContent_Hide", "ClassExtendNavTopBarSubMenuContent_Hide", "className", "children"]);
  var theme = (0, _reactJss.useTheme)();
  var classes = styles((0, _extends2["default"])({}, props, {
    theme: theme
  }));
  var Location = (0, _reactRouterDom.useLocation)();
  var History = (0, _reactRouterDom.useHistory)();

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      IsActiveLink = _React$useState2[0],
      setIsActiveLink = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(false),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      IsOpenMenu = _React$useState4[0],
      setIsOpenMenu = _React$useState4[1]; //Handle Click on Controller


  var handleToggleOpenClose = function handleToggleOpenClose() {
    setIsOpenMenu(!IsOpenMenu);
  }; //Handle Click outside


  var HandleClickOutside = function HandleClickOutside(e) {
    if (MainRef.current.contains(e.target)) {
      setIsOpenMenu(true);
    } else {
      setIsOpenMenu(false);
    }
  };

  var HandleNavigateTo = function HandleNavigateTo(slug) {
    History.push(slug);
    setIsActiveLink(true);
  }; //Function to detect if the Main Controller should be active


  _react["default"].useEffect(function () {
    var CurrentPath = Location.pathname;
    var Active = false;

    if (SlugList) {
      SlugList.forEach(function (Slug) {
        if (CurrentPath.includes(Slug)) {
          Active = true;
        }
      });
    }

    if (CurrentPath.includes(Slug)) {
      Active = true;
    }

    Active ? setIsActiveLink(true) : setIsActiveLink(false);
  }, [Location.pathname]); //Adding Click Outisde Listener


  _react["default"].useEffect(function () {
    if (IsOpenMenu) {
      document.addEventListener("mousedown", HandleClickOutside);
    } else {
      document.removeEventListener("mousedown", HandleClickOutside);
    }

    return function () {
      document.removeEventListener("mousedown", HandleClickOutside);
    };
  }, [IsOpenMenu]);

  var MainRef = _react["default"].useRef();

  var FinalClassTopBarSubMenu;

  if (ClassOverrideNavTopBarSubMenu) {
    if (IsActiveLink) {
      FinalClassTopBarSubMenu = ClassOvverideNavTopBarSubMenuActive;
    } else {
      FinalClassTopBarSubMenu = ClassOverrideNavTopBarSubMenu;
    }
  } else {
    if (IsActiveLink) {
      FinalClassTopBarSubMenu = (0, _clsx["default"])(classes.NavTopBarSubMenu, classes.NavTopBarSubMenuActive, ClassExtendNavTopBarSubMenu);
    } else {
      FinalClassTopBarSubMenu = (0, _clsx["default"])(classes.NavTopBarSubMenu, ClassExtendNavTopBarSubMenu);
    }
  }

  var FinalClassController;

  if (ClassOverrideNavTopBarSubMenu_Controller) {
    if (IsActiveLink) {
      FinalClassController = ClassOverrideNavTopBarSubMenu_Controller_Active;
    } else {
      FinalClassController = ClassOverrideNavTopBarSubMenu_Controller;
    }
  } else {
    if (IsActiveLink) {
      if (WithActiveIndicator) {
        FinalClassController = (0, _clsx["default"])(classes.NavTopBarSubMenu_Controller, classes.NavTopBarSubMenu_Controller_Active, classes.NavTopBarLink_Indicator_Active, ClassExtendNavTopBarSubMenu_Controller, ClassExtendNavTopBarSubMenu_Controller_Active, ClassExtendNavTopBarLink_Indicator_Active);
      } else {
        FinalClassController = (0, _clsx["default"])(classes.NavTopBarSubMenu_Controller, classes.NavTopBarSubMenu_Controller_Active, ClassExtendNavTopBarSubMenu_Controller, ClassExtendNavTopBarSubMenu_Controller_Active);
      }
    } else {
      if (WithActiveIndicator) {
        FinalClassController = (0, _clsx["default"])(classes.NavTopBarSubMenu_Controller, classes.NavTopBarLink_Indicator_Inactive, ClassExtendNavTopBarSubMenu_Controller, ClassExtendNavTopBarLink_Indicator_Inactive);
      } else {
        FinalClassController = (0, _clsx["default"])(classes.NavTopBarSubMenu_Controller, ClassExtendNavTopBarSubMenu_Controller);
      }
    }
  }

  var FinalClassContent;

  if (ClassOverrideNavTopBarSubMenuContent_Show) {
    if (IsOpenMenu) {
      FinalClassContent = ClassOverrideNavTopBarSubMenuContent_Show;
    } else {
      FinalClassContent = ClassOverrideNavTopBarSubMenuContent_Hide;
    }
  } else {
    if (IsOpenMenu) {
      FinalClassContent = (0, _clsx["default"])(classes.NavTopBarSubMenuContent_Show, ClassExtendNavTopBarSubMenuContent_Show);
    } else {
      FinalClassContent = (0, _clsx["default"])(classes.NavTopBarSubMenuContent_Hide, ClassExtendNavTopBarSubMenuContent_Hide);
    }
  }

  var FinalComponent;

  if (Slug) {
    FinalComponent = /*#__PURE__*/_react["default"].createElement("div", {
      ref: ref,
      className: FinalClassTopBarSubMenu,
      onClick: function onClick() {
        return HandleNavigateTo(Slug);
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      ref: MainRef,
      onClick: handleToggleOpenClose,
      className: FinalClassController
    }, ControllerContent), /*#__PURE__*/_react["default"].createElement("div", {
      className: FinalClassContent
    }, children));
  } else {
    FinalComponent = /*#__PURE__*/_react["default"].createElement("div", {
      ref: ref,
      className: FinalClassTopBarSubMenu
    }, /*#__PURE__*/_react["default"].createElement("div", {
      ref: MainRef,
      onClick: handleToggleOpenClose,
      className: FinalClassController
    }, ControllerContent), /*#__PURE__*/_react["default"].createElement("div", {
      className: FinalClassContent
    }, children));
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, FinalComponent);
});

NavTopBarSubMenu.defaultProps = {
  Slug: null,
  SlugList: null,
  ControllerContent: null,
  WithActiveIndicator: false,
  ClassOverrideNavTopBarSubMenu: null,
  ClassExtendNavTopBarSubMenu: null,
  ClassOvverideNavTopBarSubMenuActive: null,
  ClassExtendNavTopBarSubMenuActive: null,
  ClassExtendNavTopBarLink_Indicator_Inactive: null,
  ClassExtendNavTopBarLink_Indicator_Active: null,
  ClassOverrideNavTopBarSubMenu_Controller: null,
  ClassExtendNavTopBarSubMenu_Controller: null,
  ClassOverrideNavTopBarSubMenu_Controller_Active: null,
  ClassExtendNavTopBarSubMenu_Controller_Active: null,
  ClassOverrideNavTopBarSubMenuContent_Show: null,
  ClassExtendNavTopBarSubMenuContent_Show: null,
  ClassOverrideNavTopBarSubMenuContent_Hide: null,
  ClassExtendNavTopBarSubMenuContent_Hide: null
};
process.env.NODE_ENV !== "production" ? NavTopBarSubMenu.propTypes = {
  /**
   * The relative link to the page to display
   */
  Slug: _propTypes["default"].string,

  /**
   * An array containing all the slugs that should render the Controller Active
   */
  SlugList: _propTypes["default"].array,

  /**
   * The content of the Accodrion Controller
   */
  ControllerContent: _propTypes["default"].node,

  /**
   * Add an Indicator or not on top of the SideBar (border) when the link is active
   */
  WithActiveIndicator: _propTypes["default"].bool,

  /**
   * Override the class
   */
  ClassOverrideNavTopBarSubMenu: _propTypes["default"].string,

  /**
   * Extend the class
   */
  ClassExtendNavTopBarSubMenu: _propTypes["default"].string,

  /**
   * Override the class
   */
  ClassOvverideNavTopBarSubMenuActive: _propTypes["default"].string,

  /**
   * Extend the class
   */
  ClassExtendNavTopBarSubMenuActive: _propTypes["default"].string,

  /**
   * Extend the class
   */
  ClassExtendNavTopBarLink_Indicator_Inactive: _propTypes["default"].string,

  /**
   * Extend the class
   */
  ClassExtendNavTopBarLink_Indicator_Active: _propTypes["default"].string,

  /**
   * Override the class
   */
  ClassOverrideNavTopBarSubMenu_Controller: _propTypes["default"].string,

  /**
   * Extend the class
   */
  ClassExtendNavTopBarSubMenu_Controller: _propTypes["default"].string,

  /**
   * Override the class
   */
  ClassOverrideNavTopBarSubMenu_Controller_Active: _propTypes["default"].string,

  /**
   * Extend the class
   */
  ClassExtendNavTopBarSubMenu_Controller_Active: _propTypes["default"].string,

  /**
   * Override the class
   */
  ClassOverrideNavTopBarSubMenuContent_Show: _propTypes["default"].string,

  /**
   * Extend the class
   */
  ClassExtendNavTopBarSubMenuContent_Show: _propTypes["default"].string,

  /**
   * Override the class
   */
  ClassOverrideNavTopBarSubMenuContent_Hide: _propTypes["default"].string,

  /**
   * Extend the class
   */
  ClassExtendNavTopBarSubMenuContent_Hide: _propTypes["default"].string
} : void 0;
var _default = NavTopBarSubMenu;
exports["default"] = _default;